import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'searchArea',
    'form',
    'loading',
    'accordion',
    'accordionButtonOpen',
    'accordionButtonClose',
    'cityCheckbox',
    'cityId',
    'ordinanceDesignatedCityId',
    'cityList',
    'ordinanceDesignatedCityList',
    'checkboxAll',
    'checkboxes',
    'cityCheckBoxesModalNextButton',
  ]

  className () {
    return this.element.dataset.classname
  }

  toggleAccordion (e) {
    const target = e.target.parentNode
    if (target.classList.contains(`${this.className()}::accordion-close`)) {
      this.open(target)
    } else {
      this.close(target)
    }
  }

  open (target) {
    target.classList.remove(`${this.className()}::accordion-close`)
    target.classList.add(`${this.className()}::accordion-open`)

    setTimeout(() => {
      this.scrollToParent(target)
    }, 200)
  }

  close (target) {
    target.classList.remove(`${this.className()}::accordion-open`)
    target.classList.add(`${this.className()}::accordion-close`)
  }

  scrollToParent (target) {
    const parentElement = this.searchAreaTarget
    const parentOffset = parentElement.getBoundingClientRect().top
    const childOffset = target.getBoundingClientRect().top
    const scrollTo = childOffset - parentOffset + parentElement.scrollTop

    parentElement.scroll({
      top: scrollTo,
      behavior: 'smooth',
    })
  }

  getPrefecture (e) {
    e.preventDefault()
    const { valuePref } = e.target.dataset
    const loading = this.loadingTargets.filter(element => element.dataset.valuePref === e.target.dataset.valuePref)
    const hasElement = this.cityCheckboxTargets.find(element => element.dataset.valuePref === valuePref)

    if (hasElement && !hasElement.innerHTML) {
      const params = new URLSearchParams()
      params.append('prefecture_ids[]', valuePref)
      const path = '/api/areas/cities/?' + params.toString()

      const controller = typeof AbortController !== 'undefined' ? new AbortController() : null
      const timeoutId = controller ? setTimeout(() => controller.abort(), 15000) : null

      fetch(path, controller ? { signal: controller.signal } : {})
        .then(data => {
          clearTimeout(timeoutId)
          return data.json()
        })
        .then(res => {
          if (loading[0]) this.hideLoading(loading[0])
          this.cities(res)
          this.scrollToParent(e.target)
        })
        .catch((error) => {
          clearTimeout(timeoutId)
          if (loading[0]) this.hideLoading(loading[0])
          console.error('市区町村の取得に失敗しました:', error)
        })
    }
  }

  cities (data) {
    // eslint-disable-next-line camelcase
    const { id, cities, ordinance_designated_cities } = data.prefectures[0]
    const prefectureId = String(id)
    const ordinanceDesignatedCitiesList = this.createOrdinanceDesignatedCitiesList(ordinance_designated_cities)
    const citiesList = this.createCityList(cities)
    const target = this.cityCheckboxTargets.find(element => element.dataset.valuePref === prefectureId)
    if (target && !target.innerHTML) {
      // innerHTML += ではなく innerHTML = を使用してTurboとの互換性を保つ
      target.innerHTML = ordinanceDesignatedCitiesList + citiesList
    }
  }

  createOrdinanceDesignatedCitiesList (ordinanceDesignatedCities) {
    const ordinanceDesignatedCityIdTargets = this.ordinanceDesignatedCityIdTargets
    return ordinanceDesignatedCities.map(ordinanceDesignatedCity => {
      return `
        <li class="${this.className()}::checks">
            <label class="${this.className()}::check">
                <input class="check-input gtm-tap" type="checkbox" value="${ordinanceDesignatedCity.id}" name="ordinance_designated_city_ids[]" data-gtm-event="list_area_checkbox_selected" data-action="click->site--parts--search--area--mobile--component#cityCheckBoxesModalNextButtonStatus" data-site--parts--search--area--mobile--component-target="ordinanceDesignatedCityList">
                <i></i>
                <span>${ordinanceDesignatedCity.name}</span>
            </label>
        </li>`
    }).join('')
  }

  createCityList (cities) {
    const cityIdTargets = this.cityIdTargets
    return cities.map((city) => {
      return `<li class="${this.className()}::checks">
                  <label class="${this.className()}::check">
                      <input class="check-input gtm-tap" type="checkbox" value="${city.id}" name="city_ids[]" data-gtm-event="list_area_checkbox_selected" data-action="click->site--parts--search--area--mobile--component#cityCheckBoxesModalNextButtonStatus" data-site--parts--search--area--mobile--component-target="cityList">
                      <i></i>
                      <span>${city.name}</span>
                  </label>
              </li>`
    }).join('')
  }

  cityCheckBoxesModalNextButtonStatus (e) {
    const checkedFlag = [
      ...this.ordinanceDesignatedCityListTargets,
      ...this.cityListTargets,
    ].some(function (checkbox) {
      return checkbox.checked
    })

    if (checkedFlag) {
      this.cityCheckBoxesModalNextButtonTarget.classList.remove(`${this.className()}::disabled`)
    } else {
      this.cityCheckBoxesModalNextButtonTarget.classList.add(`${this.className()}::disabled`)
    }
  }

  hideLoading (target) {
    target.style.display = 'none'
  }

  checkAll (e) {
    const currentIndex = this.checkboxAllTargets.indexOf(e.currentTarget)
    const checkboxes = this.checkboxesTargets[currentIndex].querySelectorAll('input[type="checkbox"]')
    const allCheckbox = e.currentTarget
    const isChecked = allCheckbox.checked

    // チェックボックスの状態を更新
    // querySelectorAllで取得した要素は全てDOM要素だが、念のため型チェック
    checkboxes.forEach((checkbox) => {
      if (checkbox instanceof HTMLInputElement && checkbox.type === 'checkbox') {
        checkbox.checked = isChecked
      }
    })

    // 1回だけボタンのステータスを更新（無限再帰を防ぐ）
    this.cityCheckBoxesModalNextButtonStatus()
  }
}
